import Vue from 'vue'
import {Prop, Component} from 'vue-property-decorator'

@Component
class MRAutocompleteSelector extends Vue {
  @Prop({ default: false, type: [Boolean] })
  loading: boolean;

  @Prop({ default: false, type: [Boolean] })
  disabled: boolean;

  @Prop({ default: true, type: [Boolean] })
  multiple: boolean;

  @Prop({ default: false, type: [Boolean] })
  clearable: boolean;

  @Prop({ default: 'name', type: [String] })
  itemText: string;

  @Prop({ default: 'id', type: [String] })
  itemValue: string;

  @Prop({ default: 'label', type: [String] })
  label: string;

  @Prop({ default: () => ({}), type: [Function] })
  onChange: Function;

  @Prop({ default: [], type: [Array] })
  items: any[];

  @Prop({ default: 30, type: [Number] })
  truncateText: number;

  @Prop({ default: () => [], type: [Array, Number] })
  value: any;

  @Prop({ type: [Function] })
  fetch: any;


  dtSearch?: string | null;
  dtIsLoading?: boolean | null;

  constructor () {
    super()
    this.dtSearch = '';
    this.dtIsLoading = false;
  }

  get vModel (): any[] {
    return this.value
  }

  set vModel (val: any[]) {
    this.$emit('input', val)
  }

  get coIsLoading(): boolean {
    return this.loading || this.dtIsLoading;
  }

  othersText()
  {
    let selected = this.vModel
    if(selected.length===1){return ''}
    if(selected.length===2){return '+1 autre'}
    if(selected.length>2){return `+${selected.length-1} autres`}
  }

  truncate(val:string)
  {
    return val.length>this.truncateText ? `${val.substring(0,this.truncateText)} ...` : val
  }

  mounted() {
    if (this.fetch) {
      this.$watch('dtSearch', async (value: string, oldValue: string) => {
        if (value && value.length > 2 && oldValue && oldValue.length > 0){
          this.dtIsLoading = true
          await this.fetch(value);
          this.dtIsLoading = false
        }
      })
    }
  }

}

export default MRAutocompleteSelector



// WEBPACK FOOTER //
// ./src/containers/block/block-maintenances/components/MRAutocompleteSelector/index.ts